module.exports = __webpack_public_path__ + "img/bg10.360a06ed.png";